import { useAccountStore } from 'src/domain/stores/useAccountStore';
import { useBathCardsStore } from 'src/domain/stores/useBathCardsStore';
import { useExerciseStore } from 'src/domain/stores/useExerciseStore';
import { useFeaturedItemStore } from 'src/domain/stores/useFeaturedItemStore';
import { useHomeStore } from 'src/domain/stores/useHomeStore';
import { useInspirationStore } from 'src/domain/stores/useInspirationStore';
import { useLeaveAppStore } from 'src/domain/stores/useLeaveAppStore';
import { useLoyaltyStore } from 'src/domain/stores/useLoyaltyStore';
import { useMessagesStore } from 'src/domain/stores/useMessagesStore';
import { usePreferencesStore } from 'src/domain/stores/usePreferencesStore';
import { useProfileStore } from 'src/domain/stores/useProfileStore';
import { useReservationsStore } from 'src/domain/stores/useReservationsStore';
import { useReserveStore } from 'src/domain/stores/useReserveStore';
import { useResortStore } from 'src/domain/stores/useResortStore';

type ResettableStore = { name: string; store: { getState: () => { reset: () => void } } };

export const MEMBER_DATA_STORES: ResettableStore[] = [
	{ name: 'useAccountStore', store: useAccountStore },
	{ name: 'useBathCardsStore', store: useBathCardsStore },
	{ name: 'useExerciseStore', store: useExerciseStore },
	{ name: 'useFeaturedItemStore', store: useFeaturedItemStore },
	{ name: 'useHomeStore', store: useHomeStore },
	{ name: 'useInspirationStore', store: useInspirationStore },
	{ name: 'useLeaveAppStore', store: useLeaveAppStore },
	{ name: 'useLoyaltyStore', store: useLoyaltyStore },
	{ name: 'useMessagesStore', store: useMessagesStore },
	{ name: 'usePreferencesStore', store: usePreferencesStore },
	{ name: 'useProfileStore', store: useProfileStore },
	{ name: 'useReservationsStore', store: useReservationsStore },
	{ name: 'useReserveStore', store: useReserveStore },
	{ name: 'useResortStore', store: useResortStore },
];

export const resetMemberDataStores = () => {
	MEMBER_DATA_STORES.forEach(({ store }) => store.getState().reset());
};
